import React, { useEffect, useRef } from "react";
import TimeLeft from "../timeLeft";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import enquire from "enquire.js";

import { ReactComponent as SmsIcon } from "../imgComponents/product-logo-icon-sms-marketing.svg";
import { ReactComponent as LoyaltyIcon } from "../imgComponents/product-logo-icon-loyalty.svg";
import { ReactComponent as ReviewsIcon } from "../imgComponents/product-logo-icon-reviews.svg";
import { ReactComponent as VisualUGCIcon } from "../imgComponents/product-logo-icon-visual-ugc.svg";
import { ReactComponent as SubscriptionsIcon } from "../imgComponents/product-logo-icon-subscriptions.svg";
import "../../css/inner-page/sectionYotpoProducts.scss";

export default function Section(props) {
  const swiperRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//fast.wistia.com/assets/external/E-v1.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const videoId = props.videoId;
    if (videoId) {
      const videoSection = document.querySelector("#yotpo-products .scroll-navigation");
      videoSection.scrollIntoView({ behavior: "smooth" });
    }
    props.gallery.map((item, index) => {
      if (props.videoId === item.wistia_video_id) {
        swiperRef.current.swiper.slideTo(index);
      }
      return true;
    });
  }, [props.videoId, swiperRef]);

  useEffect(() => {
    setWistiaVideoOptions();
  }, []);

  const setWistiaVideoOptions = () =>
    enquire.register(`(max-width:375px)`, {
      match: function () {
        window._wq = window._wq || [];
        props.gallery.map((item, index) => {
          let videoEl = document.getElementById(`wistia-${item.wistia_video_id}-${index}`);
          const classes = [
            "popover=true",
            "popoverContent=html",
            "popoverDisableAutoPlay=true",
            "autoPlay=false",
            "autoplayVideo=false",
          ];
          const autoplayVideo = props.videoId === item.wistia_video_id ? "true" : "false";
          videoEl.classList.remove(...classes);

          window._wq.push({
            id: item.wistia_video_id,
            options: { autoPlay: autoplayVideo, controlsVisibleOnLoad: false },
            onplay: function (video) {
              video.controls(true);
            },
          });
        });
      },
    });

  const products = {
    "sms-marketing": { title: "SMSBump", component: SmsIcon },
    loyalty: { title: "Loyalty & Referrals", component: LoyaltyIcon },
    reviews: { title: "Reviews", component: ReviewsIcon },
    "visual-ugc": { title: "Visual UGC", component: VisualUGCIcon },
    subscriptions: { title: "Subscriptions", component: SubscriptionsIcon },
  };
  const Product = (props) => {
    const ProductComp = products[props.product].component;
    return <ProductComp />;
  };

  const handleVideoClick = (title) => {
    if (typeof window.redcross !== "undefined") {
      const obj = {
        btnText: title,
        btnContext: "",
        btnName: "BFCM Expert videos",
        btnLocation: `BFCM Expert videos`,
      };
      window.redcross.track("Button Clicked", obj);
    }
  };

  return (
    <section id="yotpo-products">
      <h2 data-aos="fade">{props.title}</h2>
      <h3 data-aos="fade">{props.subtitle}</h3>

      <div className="scroll-navigation">
        <button className="icon before" onClick={() => swiperRef.current.swiper.slidePrev()}></button>
        Scroll between tips
        <button className="icon after" onClick={() => swiperRef.current.swiper.slideNext()}></button>
      </div>

      <div className="yotpo-products-wrapper">
        <Swiper
          spaceBetween={70}
          slidesPerView={1}
          grabCursor={true}
          modules={[Navigation]}
          ref={swiperRef}
          breakpoints={{
            768: {
              spaceBetween: 0,
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            1024: {
              spaceBetween: 0,
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            1280: {
              spaceBetween: 0,
              slidesPerView: 4,
              slidesPerGroup: 4,
            },
            1920: {
              spaceBetween: 0,
              slidesPerView: 5,
              slidesPerGroup: 5,
            },
          }}
        >
          {props.gallery.map((item, index) => {
            const autoplayVideo = props.videoId === item.wistia_video_id ? "true" : "false";
            return (
              <SwiperSlide key={index}>
                {item.coming_soon ? (
                  <div className="coming-soon">
                    <img src={item.image_group["1x"]} alt={item.image_group.alt} />
                    <div className="yotpo-product-content">
                      <span className="title">{item.title}</span>
                      <span className="name">{item.name}</span>
                      <span className="coming-soon-label">COMING SOON</span>
                      <span className="timer">
                        <TimeLeft datetime={item.time_until_available} />
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="ongoing">
                    <div
                      onClick={() => handleVideoClick(item.title)}
                      id={`wistia-${item.wistia_video_id}-${index}`}
                      className={`wistia_embed wistia_async_${item.wistia_video_id}   popover=true popoverContent=html popoverDisableAutoPlay=true popoverShowOnLoad=${autoplayVideo}`}
                    >
                      <div id="wistia_13.thumb_container" className="thumb">
                        <img src={item.image_group["1x"]} alt={item.image_group.alt} />
                      </div>
                    </div>
                    <div className="yotpo-product-content">
                      <span className="title">{item.title}</span>
                      <span className="name">{item.name}</span>
                      <div className="products-wrapper">
                        {item.products.map((product, index) => {
                          return (
                            <span key={index} className="product">
                              <Product product={product.group} />
                              <span className="product-name">{products[product.group].title}</span>
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}
